import React, { useCallback } from 'react';
import { NavLink }            from 'react-router-dom';

import needReset      from '../../../../common/tools/need-reset';
import { useCatalog } from '../../../../providers/catalog';

const BreadcrumbItem = function({
  title,
  url = '',
  search = '',
  position,
  isLast,
}) {
  const {
          resetFilter,
          getCatalogItems,
        } = useCatalog();

  const handleClick = useCallback((url, search) => {
    scrollTo({ top: 0 });

    if (needReset(`/${url}`)) {
      void resetFilter();

      void getCatalogItems(`/${url}${search}`);
    }
  }, [getCatalogItems, resetFilter]);

  if (!title) {
    return null;
  }

  return (
    <li
      itemProp={'itemListElement'}
      itemScope
      itemType={'https://schema.org/ListItem'}
    >
      <NavLink
        to={{
          pathname: `${url.startsWith('/') ? url : `/${url}`}`,
          search,
          state:    { noRedirect: true },
        }}
        itemProp={'item'}
        onClick={() => handleClick(url, search)}
        style={{
          pointerEvents: isLast ? 'none' : 'auto',
          color:         isLast ? '#667085' : '#bcbcbc',
        }}
      >
        <span itemProp={'name'}>{title}</span>
      </NavLink>
      <meta itemProp={'position'} content={position} />
    </li>
  );
};

export default BreadcrumbItem;